var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSidebarResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 4.25,
    width: 6.5,
    height: 6.5,
    rx: 1.25,
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 13.25,
    width: 6.5,
    height: 6.5,
    rx: 1.25,
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 4.25,
    width: 6.5,
    height: 6.5,
    rx: 1.25,
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 13.25,
    width: 6.5,
    height: 6.5,
    rx: 1.25,
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSidebarResearch);
export default __webpack_public_path__ + "static/media/ico_sidebar_research.31cf16641f95e6b30a7fde4950c308fc.svg";
export { ForwardRef as ReactComponent };